import React from "react";
import { Link } from "react-router-dom";
import ServicePageTemplate from "./ServicePageTemplate";

const CommercialCleaningPage = () => {
  const pageData = {
    pageTitle: "Commercial Cleaning Cardiff | Contract & Business Cleaners",
    metaDescription: "Commercial cleaners in Cardiff, Barry and Penarth. Contract cleaning for offices, shops and workplaces, before or after business hours. Fully insured. Request a free business quote.",
    quoteService: "Commercial Cleaning",
    heroImageAlt: "Clean commercial office space in Cardiff after a professional clean",
    
    heroTitle: "Commercial Cleaning Services in Cardiff",
    heroSubtitle: "Contract cleaning for offices, shops, clinics and workplaces across Cardiff, Barry and Penarth. Flexible scheduling to suit your business.",
    heroImage: "https://images.unsplash.com/photo-1497366754035-f200968a6e72?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHw0fHxvZmZpY2UlMjBjbGVhbmluZ3xlbnwwfHx8fDE3NzU5MDkwMDZ8MA&ixlib=rb-4.1.0&q=85",
    
    serviceDescription: (
      <>
        <p className="mb-4">
          Create a professional, welcoming environment for your staff and clients with NeatWave's commercial cleaning service. We provide reliable business cleaning services for offices, shops, clinics and other workplaces throughout Cardiff, <Link to="/cleaning-services-barry">Barry</Link> and <Link to="/cleaning-services-penarth">Penarth</Link>.
        </p>
        <h2>Contract cleaning for Cardiff businesses</h2>
        <p className="mb-4">
          Our commercial cleaning is built around your business. Whether you need daily workplace cleaning, weekly shop cleaning or out-of-hours service, we work around your schedule to minimise disruption. All cleaners are DBS-checked and trained to a written checklist agreed with you. Looking specifically for office cleaners? See our <Link to="/office-cleaning-cardiff">office cleaning in Cardiff</Link> page.
        </p>
        <h3>Tailored to your premises</h3>
        <p className="mb-4">
          Every business is different. From small start-ups to established companies, we tailor the service to your requirements, budget and premises. NeatWave is fully insured, and we're happy to share our insurance details when you request a quote.
        </p>
      </>
    ),
    
    whatIncluded: [
      {
        title: "Workspaces & Desks",
        description: "Clean desks, keyboards, phones, monitors, empty bins, organize cables"
      },
      {
        title: "Reception & Common Areas",
        description: "Reception desk, waiting areas, communal spaces, glass doors, entrance cleaning"
      },
      {
        title: "Kitchen & Break Rooms",
        description: "Clean appliances, worktops, sink, restock supplies, empty bins, wipe tables"
      },
      {
        title: "Bathrooms & Washrooms",
        description: "Thorough clean, sanitize, restock supplies, check functionality"
      },
      {
        title: "Floors & Carpets",
        description: "Vacuum all carpets, mop hard floors, spot clean high-traffic areas"
      },
      {
        title: "Windows & Glass",
        description: "Clean interior windows, glass partitions, mirrors, glass doors"
      }
    ],
    
    pricingInfo: {
      duration: "2-7 hours",
      price: "From £80",
      note: "Pricing based on premises size, frequency, and specific requirements. Daily office cleaning from £80, weekly from £100. Out-of-hours service available. Contact us for a tailored business quote."
    },
    
    faqs: [
      {
        q: "Where can I find commercial cleaners near me in Cardiff?",
        a: "NeatWave provides commercial cleaning across Cardiff, Barry and Penarth for offices, shops, clinics and workplaces. Call 0749 286 5011 or request a quote online."
      },
      {
        q: "Can you clean outside of business hours?",
        a: "Yes! We offer out-of-hours cleaning including early morning, evening, and weekend service. This ensures no disruption to your business operations. Most of our commercial clients prefer evening cleans after staff leave."
      },
      {
        q: "Do you provide cleaning supplies and equipment?",
        a: "Yes, we supply all professional cleaning products, equipment, and consumables (toilet paper, hand soap, etc.). We use commercial-grade, effective products. If you have specific product preferences or requirements, we can accommodate."
      },
      {
        q: "Are your cleaners vetted and insured?",
        a: "Yes. All our commercial cleaners are DBS-checked and trained, and NeatWave is fully insured. We take security and professionalism very seriously and can share insurance details on request."
      },
      {
        q: "What if we need additional cleaning?",
        a: "We're flexible! If you need extra cleans for events, deep cleans, or increased frequency, just let us know. We can arrange one-off additional services or adjust your regular schedule as your business needs change."
      },
      {
        q: "How long is the contract?",
        a: "We offer flexible contracts to suit your needs - monthly rolling contracts or longer-term agreements with better rates. No lengthy commitments required. Many clients start with a trial period to ensure our service meets their expectations."
      }
    ],
    
    testimonial: {
      text: "The service was excellent, professional, and reliable, with great attention to detail. I would confidently recommend NeatWave Cleaning Services to anyone looking for quality cleaning services.",
      author: "Elvis Madu, Google review"
    },
    
    relatedServices: [
      {
        title: "Office Cleaning",
        description: "Daily or weekly office cleaners in Cardiff",
        url: "/office-cleaning-cardiff"
      },
      {
        title: "Deep Cleaning",
        description: "Quarterly deep clean for commercial premises",
        url: "/deep-cleaning-cardiff"
      },
      {
        title: "End of Tenancy Cleaning",
        description: "Office relocation or lease end cleaning",
        url: "/end-of-tenancy-cleaning-cardiff"
      }
    ]
  };

  return <ServicePageTemplate {...pageData} />;
};

export default CommercialCleaningPage;